import { render } from "./CurrencySymbol.vue?vue&type=template&id=6e078bc2"
import script from "./CurrencySymbol.vue?vue&type=script&lang=js"
export * from "./CurrencySymbol.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/doso-frontend/doso-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__